<template>
  <div class="spaceduck-collapse"
       :id="id"
       :class="{ show: stateCollapsed }">
    <slot/>
  </div>
</template>

<script setup>
import { computed, onMounted, watch } from "vue"
import { useStore } from "vuex"

const props = defineProps({
  visible: {},
  id: {}
})

const emit = defineEmits(['show', 'hide'])

const store = useStore()

// open state lives in the store (dom.spaceduckCollapse), toggled by the v-spaceduck-collapse directive
const collapseDictionary = computed(() => store.state.dom.spaceduckCollapse)
const stateCollapsed = computed(() => collapseDictionary.value[props.id])

// created before the immediate `visible` watcher (as in the former options api component):
// a collapse mounted with visible = true emits 'show'
watch(stateCollapsed, (val) => {
  if(val) emit('show')
  if(!val) emit('hide')
})

watch(() => props.visible, (val) => {
  store.commit('setSpaceduckCollapse', {
    key: props.id,
    value: val
  })
}, { immediate: true })

onMounted(() => {
  store.commit('setSpaceduckCollapse', { // do not delete, immediate watcher not always working
    key: props.id,
    value: props.visible
  })
})
</script>

<style scoped lang="scss">
  .spaceduck-collapse {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.15s ease-in-out;
    &.show {
      max-height: none;
      overflow: visible;
    }
  }
</style>
